import { useSearchParams } from "react-router-dom";

const useSearchFilters = () => {
    const [searchParams, setSearchParams] = useSearchParams();

    const onChangeManager = (_, option) => {
        const newParams = new URLSearchParams(searchParams);
        newParams.delete("manager_ids");
        option.value.forEach((val) => {
            return newParams.append("manager_ids", val.org_data.id);
        });

        return setSearchParams(newParams);
    };

    const onChangeAgency = (_, option) => {
        const newParams = new URLSearchParams(searchParams);
        newParams.delete("agency_ids");
        option.value.forEach((val) => {
            return newParams.append("agency_ids", val.org_data.id);
        });

        return setSearchParams(newParams);
    };

    return {
        states: {
            searchParams,
            setSearchParams,
            querySearchValue: searchParams.get("q") || "",
        },
        handlers: {
            onChangeManager,
            onChangeAgency,
        },
    };
};

export default useSearchFilters;
